export default __webpack_public_path__ + "static/media/self1-image.21172652.png";